var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[(_vm.$vuetify.breakpoint.smAndUp)?_c('div',[_c('HomeHeader'),_c('HomeAboutApp'),_c('HomeHowItsWork'),_c('HomeFooter')],1):_c('HomeMobile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }